var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.68822C4 7.46886 5.03319 6.48037 6.30769 6.48037H10.1835C10.6645 6.48037 11.1335 6.33659 11.5249 6.06912L17.1755 2.20757C17.9392 1.68567 19 2.20797 19 3.10587V20.8941C19 21.792 17.9392 22.3143 17.1755 21.7924L11.5249 17.9309C11.1335 17.6634 10.6645 17.5196 10.1835 17.5196H6.30769C5.03319 17.5196 4 16.5311 4 15.3118V8.68822Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.9e20ee02ea533d1736e2bb7e1d135e02.svg";
export { ForwardRef as ReactComponent };